import { createStore } from "effector";
import { fetchGetPlayerData } from ".";
import { PlayerConfig } from "../types/tokenValley";


export const $gameConfig = createStore<PlayerConfig | null>(null)
    .on(fetchGetPlayerData.doneData,(_, newData) => newData.config );